export default "__VITE_ASSET__BuA3tgdT__"